import axios from "axios";
import { Config } from "../../../core/config/config";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/report/superset`;
export const supersetService = {
    async getSalesPerformanceDashboard() {
        return axios.get(`${GATEWAY_URL}/sales-performance`)
        .then((response) => {
            return response.data;
        });
    },
    async getLiveSalesDashboard() {
        return axios.get(`${GATEWAY_URL}/live-sales`)
        .then((response) => {
            return response.data;
        });
    },
    async getStockDashboard() {
        return axios.get(`${GATEWAY_URL}/stock`)
        .then((response) => {
            return response.data;
        });
    }
}
